import React, { useState } from "react";
import { Button, Drawer, Form, Row, Col, Space } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import AttachmentComponent from "CommonComponents/Attachments/Attachments";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";
import {
  uploadAttachment,
  getAttachments,
} from "CommonComponents/Attachments/AttachmentsAPI";
import { useParams } from "react-router-dom";
import FormType from "features/Enums/FormType";

function LeadFileForm(props) {
  const [form] = Form.useForm();
  const { leadId } = useParams();
  const dispatch = useDispatch();
  const formTypeId = Object.values(FormType).find(
    (f) => f.name === "LeadFiles"
  )?.id;

  const onSave = () => {
    if (leadId) {
      dispatch(uploadAttachment(leadId, formTypeId)).then(() => {
        props?.onClose();
        dispatch(getAttachments(leadId, formTypeId));
      });
    }
  };

  return (
    <Drawer
      title={<FormattedMessage id="LeadFile.AddnewFile" />}
      onClose={props?.onClose}
      open={props?.open}
      width="500px"
      fileList={props?.displayData}
    >
      <Form
        name="file-form"
        layout="vertical"
        autoComplete="off"
        size="large"
        form={form}
        onFinish={onSave}
      >
        <Form.Item
          label={<FormattedMessage id="Common.Attachment" />}
          name="attachment"
        >
          <AttachmentComponent
            identifier={formTypeId}
            currentId={leadId}
            getattachments={true}
          />
        </Form.Item>
        <Row>
          <Col span={24} className="text-center mt-10">
            <Space>
              <Button danger size="medium" onClick={props?.onClose}>
                <CloseCircleOutlined />{" "}
                {<FormattedMessage id="Common.Cancel" />}
              </Button>
              <Button type="primary" size="medium" htmlType="submit">
                <CheckCircleOutlined /> {<FormattedMessage id="Common.Save" />}
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Drawer>
  );
}

export default LeadFileForm;
